// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7uOhq","headerWrapper":"style_headerWrapper__nR-DT","title":"style_title__FUMNI","img":"style_img__AouW6"};